import { debounce } from 'throttle-debounce';
import matchQuery from './utility/matchQuery';

const scrollingElement = document.scrollingElement || document.documentElement;
const element = document.querySelector('.js-eyecatch');

// CSS maskに対応しているかどうか
function supportsCssMask() {
  return window.CSS && window.CSS.supports(`(mask: url()) or (-webkit-mask: url())`);
}

// 動画の読み込みを待つ
// CSS maskに対応していれば動画を再生、
// そうでなければなにもせず 1秒後にresolve()
function loadVideo() {
  const videoElement = element.querySelector('.js-eyecatchVideo');

  return new Promise((resolve) => {
    if (supportsCssMask()) {
      videoElement.addEventListener('canplay', () => {
        videoElement.play();
        resolve();
      });
      videoElement.load();
    } else {
      element.dataset.initialized = true;
    }
  });
}

// 要素の位置を調整
// PCレイアウトではヘッダーの下に潜り込ませる
function setPosition() {
  const offsetTop = matchQuery('md')
    ? -(element.getBoundingClientRect().top + scrollingElement.scrollTop)
    : 0;

  element.style.marginTop = `${offsetTop}px`;
}

// リサイズハンドラ
function resizeHandler() {
  element.style.marginTop = '';
  requestAnimationFrame(setPosition);
}

// 初期化
function setup() {
  setPosition();

  loadVideo().finally(() => {
    element.dataset.initialized = true;
  });
}

export default function setupEyecatch() {
  if (element) {
    setup();

    window.addEventListener('resize', debounce(500, resizeHandler));
  }
}
